import React from 'react';
import PropTypes from 'prop-types';

import withModal from '../../../../../../../../components/global/modal/withModal';
import { getAsset } from '../../../../../../../../util/assets';
import Button from '../../../../../../../../components/global/Button';
import DismissButton from '../../../../../../../../components/global/DismissButton';

const VIDEO_GUESTBOOK_CONTRIBUTOR_RECORD_MODAL =
  'modal/VIDEO_GUESTBOOK_CONTRIBUTOR_RECORD';

const propTypes = {
  onRecord: PropTypes.func.isRequired,
  onDismiss: PropTypes.func.isRequired,
  albumFolder: PropTypes.shape({
    id: PropTypes.string,
  }),
};

const VideoGuestBookContributorRecordModal = ({
  onRecord,
  onDismiss,
  albumFolder,
}) => {
  return (
    <div className="video-guest-book-contributor-record-modal">
      <img
        className="wedding-rings-header-icon"
        src={getAsset('/wedding-event-icon.png')}
        alt="Your wedding event"
      />
      <DismissButton
        onClick={onDismiss}
        className="wedding-event-purchase-dismiss"
        width="48px"
      />
      <p className="text-uppercase text-primary text-sm text-extra-bold">
        Welcome to
      </p>
      <h2 className="text-black mb-5">{albumFolder.name}!</h2>
      <img
        src={getAsset('/groove-blue.svg')}
        alt=""
        className="video-guestbook-modal-groove"
      />{' '}
      <div className="video-guestbook-modal-info-block">
        <img
          src={getAsset('/waldo-wed-vgb-banner-photo.png')}
          alt="Record your video"
          width={350}
        />

        <div>
          <h3>Express your well wishes!</h3>
          <p className="mb-0">
            Record and upload a video message for the happy couple in their
            Video Guestbook!
          </p>

          <div className="mt-2 d-flex flex-column">
            <Button onClick={onRecord}>Record my greeting now</Button>
            <Button
              btnStyle="link"
              className="mt-2 text-extra-bold"
              onClick={onDismiss}
              btnSize="xs"
            >
              Maybe later
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

VideoGuestBookContributorRecordModal.propTypes = propTypes;

export default withModal(VideoGuestBookContributorRecordModal, {
  name: VIDEO_GUESTBOOK_CONTRIBUTOR_RECORD_MODAL,
  className: 'video-guestbook-modal',
  overlayClassName: 'video-guestbook-modal-overlay',
  size: 'md',
  type: 'full',
  hideHeader: true,
});
